import * as C from "../constants/newsletterConstants";

const initialListState = {
  subscribers: [],
  counts: { total: 0, active: 0, unsubscribed: 0 },
  page: 1,
  pages: 1,
  filteredTotal: 0,
};

export const newsletterAdminListReducer = (
  state = initialListState,
  action,
) => {
  switch (action.type) {
    case C.NEWSLETTER_ADMIN_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case C.NEWSLETTER_ADMIN_LIST_SUCCESS:
      return {
        loading: false,
        subscribers: Array.isArray(action.payload?.subscribers)
          ? action.payload.subscribers
          : [],
        counts: {
          total: Number(action.payload?.counts?.total || 0),
          active: Number(action.payload?.counts?.active || 0),
          unsubscribed: Number(action.payload?.counts?.unsubscribed || 0),
        },
        page: Number(action.payload?.page || 1),
        pages: Number(action.payload?.pages || 1),
        filteredTotal: Number(action.payload?.filteredTotal || 0),
      };
    case C.NEWSLETTER_ADMIN_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const newsletterSendReducer = (state = {}, action) => {
  switch (action.type) {
    case C.NEWSLETTER_SEND_REQUEST:
      return { loading: true };
    case C.NEWSLETTER_SEND_SUCCESS:
      return {
        loading: false,
        success: true,
        result: action.payload,
      };
    case C.NEWSLETTER_SEND_FAIL:
      return { loading: false, error: action.payload };
    case C.NEWSLETTER_SEND_RESET:
      return {};
    default:
      return state;
  }
};
